<template>
  <div>
    <div tabindex="0" ref="modal" class="modal-mask"></div>

    <rare-modal-close-icon-large
      class="rareModalCloseIcon show-for-medium"
      @clicked="closeModal"
    />

    <rare-modal-close-icon-medium
      class="rareModalCloseIcon show-for-small-only"
      @clicked="closeModal"
    />

    <div class="modal-wrapper">
      <div class="modal-container">

        <div class="modal-header">
          <div class="grid-container full">
            <div class="grid-x">
              <div class="small-12 medium-12 cell text-left page-contents-15">
                <h1>{{ header }}</h1>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body">
          <div class="grid-container full">
            <div class="grid-x">
              <div class="small-12 medium-12 cell page-contents-15">
                <hr/>
                <component
                  :is="content"
                  @openManageCookies="openManageCookies"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            &nbsp;<div class="grid-container full">
            <div class="grid-x">
              <div class="small-12 medium-12 cell text-left page-contents-15">
                &nbsp;
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RareStandardButton from 'rare-patternlab/buttons/RareStandardButton';
import RareModalCloseIconLarge from 'rare-patternlab/icons/navigation/RareModalCloseIconLargeBlack';
import RareModalCloseIconMedium from 'rare-patternlab/icons/navigation/RareModalCloseIconMediumBlack';

import RareLegalFAQ from './components/RareLegalFAQ';
import RareLegalQualifiedLawyersFAQ from './components/RareLegalQualifiedLawyersFAQ';
import RareLegalCandidateExpensesPolicy from './components/RareLegalCandidateExpensesPolicy';
import RareLegalCookiePolicy from './components/RareLegalCookiePolicy';
import RareLegalAccessibilityPolicy from './components/RareLegalAccessibilityPolicy';
import RareModernSlaveryStatement from './components/RareLegalModernSlaveryStatement';
import RareLegalPrivacyPolicy from './components/RareLegalPrivacyPolicy';
import RareLegalWebsiteTermsOfUse from './components/RareLegalWebsiteTermsOfUse';


export default {
  name: 'navigationModal',
  components: {
    'rare-apply-now-button': RareStandardButton,
    'rare-modal-close-icon-medium': RareModalCloseIconMedium,
    'rare-modal-close-icon-large': RareModalCloseIconLarge,
    'rare-legal-faq': RareLegalFAQ,
    'rare-legal-candidate-expenses-policy': RareLegalCandidateExpensesPolicy,
    'rare-legal-cookie-policy': RareLegalCookiePolicy,
    'rare-legal-accessibility-policy': RareLegalAccessibilityPolicy,
    'rare-legal-modern-slavery-statement': RareModernSlaveryStatement,
    'rare-legal-privacy-policy': RareLegalPrivacyPolicy,
    'rare-legal-website-terms-of-use': RareLegalWebsiteTermsOfUse,
    'rare-legal-qualified-lawyers-faq': RareLegalQualifiedLawyersFAQ,

  },
  data() {
    return {
      referrer: '',
    };
  },
  props: {
    header: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeModal() {
      if (this.referrer.includes('apply') || this.referrer.includes('application') || history.length === 1) {
        this.$router.push('/');
      } else {
        this.$router.go(-1);
      }
    },
    openManageCookies() {
      this.$emit('openManageCookies', true);
    },
    watchForEsc(key) {
      if (key.keyCode === 27) {
        this.closeModal();
      }
    },
  },
  created() {
    document.addEventListener('keyup', this.watchForEsc);
  },
  mounted() {
    this.$refs.modal.focus();
  },
  destroyed() {
    document.removeEventListener('keyup', this.watchForEsc);
  },
};
</script>

  <style lang="scss" scoped>

    @import "~@/css/global.scss";

    .modal-mask {
      position: fixed;
      z-index: 9990;
      top: 0;
      left: 0;
      width: 100%;
      height: 200%;
      display: table;
      transition: opacity .3s ease;
      background-color: rgba(255,255,255, 1);
      overflow: scroll;
    }

    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
      opacity: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 9991;
    }

    .modal-container {
      width: 100%;
      margin: 0px auto;
      padding: 0;
      background-color: transparent;
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
      opacity: 1;
    }


    .modal-body {
      margin: 0;
    }

    .modal-default-button {
      float: right;
    }

    /* NAVIGATION TEXT STYLES FOR BOTH SIZES */

    hr {
      margin: 0 auto 36px 0 !important;
      border-bottom: 1px solid #c4cace;
    }

    h1 {
      color: $main-text;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
    }

    p, h2, h3 {
      color: $main-text;
    }


    @media only screen and (max-width: 640px)  {


      .rareModalCloseIcon {
        cursor: pointer;
        position: absolute;
        right: 8px;
        top: 22px;
        z-index: 9995;
      }

      h1 {
        font-size: 24px;
        line-height: 1.33;
        letter-spacing: 3px;
        margin: 80px 0 16px 0;
      }

    }

    @media only screen and (min-width: 641px)  {
      .rareModalCloseIcon {
        cursor: pointer;
        position: absolute;
        right: 124px;
        top: 84px;
        z-index: 9995;
      }

      h1 {
        font-size: 48px;
        line-height: 0.83;
        letter-spacing: 8px;
        margin: 88px 0 47px 0;
      }

    }

  </style>



// WEBPACK FOOTER //
// src/pages/legal/RareLegalPageWrapper.vue